import { buildTranslate } from 'locales'
import React from 'react'
import Helmet from 'react-helmet'
import { useStyletron } from 'styletron-react'
import { merchantTheme } from 'theme'
import CtaSection from './CtaSection'
import HelpSection from './HelpSection'
import Hero from './Hero'
import InstantRecovery from './InstantRecovery'
import LosingGuests from './LosingGuests'
import RoiSection from './RoiSection'
import useShowRoiSection from './useShowRoiSection'

const t = buildTranslate('recovery_ai')

// The static RecoveryAI marketing page shown at /recovery_ai until the merchant
// has an ACTIVE recovery config (see Landing's gate). It replaces the console
// chrome outright — no PageHeader, no tabs — so it owns the page title and the
// full-bleed scroll surface. Each section paints its own background and padding
// (Figma alternates white and grey05 bands), so the container only supplies the
// white base the white sections sit on.
const PromoLanding = () => {
  const [css] = useStyletron()
  // Unified ROI-visibility gate (D2/D10/D14/D15): hides the whole section for
  // a brand live <30 days, still loading, or with no computable non-zero 👎
  // upside. Composed here (not inside RoiSection) so RoiSection stays
  // data-pure — see useShowRoiSection's own docstring for the full predicate.
  const showRoi = useShowRoiSection()

  return (
    <div
      className={css({
        backgroundColor: merchantTheme.colors.white,
        minHeight: '100vh',
        width: '100%',
      })}
    >
      <Helmet>
        <title>{t('page_title')}</title>
      </Helmet>
      <Hero />
      <LosingGuests />
      <InstantRecovery />
      {showRoi && <RoiSection />}
      <CtaSection />
      <HelpSection />
    </div>
  )
}

export default PromoLanding
